import React, {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import PropTypes from 'prop-types';
import Input from "@mui/material/Input/Input";
// eslint-disable-next-line no-unused-vars
import { enqueueSnackbar } from 'notistack'

function ViewFolderLinkDialog (props) {

    const [open, setOpen] = useState(true)
    const [textArea, setTextArea] = useState()
    
    const handleCloseDialog = () => {
       setOpen(false)
       props.handleCloseMenu && props.handleCloseMenu()
        
        //Added this to address issue of dialog not re-opening after initial open
        props.handleCloseDialog && props.handleCloseDialog()
    };

    const copyToClipboard = (e) => {
        textArea.select();
        document.execCommand('copy');
        e.target.focus();
        enqueueSnackbar("URL copied to clipboard", {variant: 'success'})
    };


    return (
        <div>
            <Dialog
                open={open}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogContent>
                    <DialogContentText sx={(theme)=>({paddingBottom: theme.spacing(2)})}>
                        {props.actionConfig.dialogText}
                    </DialogContentText>
                    <br/>

                    <Input
                        id = "fileLink"
                        name = "fileLink"
                        value = {window.location.origin + "/folder/" + props.folderId}
                        inputRef = {(textarea) => setTextArea(textarea)}
                        type = "text"
                        margin="none"
                        variant="outlined"
                        readOnly={true}
                        style={{width: "100%"}}
                        autoFocus={true}
                        onFocus={event => {event.target.select()}}
                    />

                </DialogContent>

                <DialogActions>
                    <Button onClick={copyToClipboard}
                            variant="contained"
                            color="secondary">
                        Copy to Clipboard
                    </Button>
                    <Button onClick={handleCloseDialog}
                            variant="contained"
                            color="secondary">
                        Close
                    </Button>

                </DialogActions>
            </Dialog>
        </div>
    );
}

ViewFolderLinkDialog.propTypes = {
    classes: PropTypes.object,
    folderId: PropTypes.string.isRequired,
    handleCloseDialog: PropTypes.func.isRequired,
    handleCloseMenu: PropTypes.func,
    actionConfig: PropTypes.object.isRequired
};


export default (ViewFolderLinkDialog);